export default "__VITE_ASSET__D2CmV2BT__"